import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import posthog from 'posthog-js';

@Injectable()
export class CreateInvoiceGuard {
public canActivate(): boolean {
	if (environment.posthog) {
		return posthog.isFeatureEnabled('new-create-invoice');
	}
}
}
